import { NavLink } from 'react-router';
import { useNavItems } from '../navigation.js';

/**
 * Barra de abas do mobile (spec 9.1): 64px + safe-area, sempre visivel.
 * `env(safe-area-inset-bottom)` evita que o iPhone corte a ultima linha.
 */
export function TabBar() {
  const abas = useNavItems();

  return (
    <nav
      aria-label="Navegação principal"
      className="fixed inset-x-0 bottom-0 z-20 flex border-t border-border bg-surface md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {abas.map((item) => (
        <NavLink
          key={item.id}
          to={item.path}
          className={({ isActive }) =>
            [
              'flex flex-1 flex-col items-center justify-center gap-1 text-xs transition-colors duration-150',
              'min-h-tabbar',
              isActive ? 'text-brand-blue' : 'text-text-mut',
            ].join(' ')
          }
        >
          {({ isActive }) => (
            <>
              <span aria-hidden="true" className="text-md">
                {item.glyph}
              </span>
              <span className={isActive ? 'font-medium' : undefined}>{item.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
